import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ArrowRight } from '@outdoor-voices/ui';
import { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import SearchIcon from '@outdoor-voices/ui/dist/components/icons/Search';
import { ROOT_URL } from './constants';
import css from './Search.module.scss';
import Suggestions from './Suggestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Search = function Search(_ref) {
  var onSearch = _ref.onSearch;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      term = _useState2[0],
      setTerm = _useState2[1];

  var history = useHistory();

  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    history.push("".concat(ROOT_URL, "-search?q=").concat(term));
    onSearch(term);
  };

  var label = 'Search for “return” or “size”';

  var icon = /*#__PURE__*/_jsx("div", {
    className: css.icon,
    children: /*#__PURE__*/_jsx(SearchIcon, {})
  });

  return /*#__PURE__*/_jsxs("form", {
    className: css.root,
    onSubmit: onSubmit,
    children: [/*#__PURE__*/_jsx(Suggestions, {
      hideLabel: true,
      icon: icon,
      id: "faq-search",
      inline: true,
      label: "Search the help center articles",
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;
        return setTerm(value);
      },
      onClear: function onClear() {
        return setTerm('');
      },
      placeholder: label,
      value: term
    }), /*#__PURE__*/_jsx("button", {
      "aria-label": "Click to search support articles",
      className: css.submit,
      type: "submit",
      children: /*#__PURE__*/_jsx(ArrowRight, {})
    })]
  });
};

Search.propTypes = {
  onSearch: PropTypes.func
};
export default /*#__PURE__*/memo(Search);